module.exports = __webpack_public_path__ + "img/workshops_mobile.79aca7ac.svg";